import React, { FC, useEffect } from "react";

import close from "../../assets/close.svg";
import { toggleModalOpenClass } from "../../utilities/helpers";
import "./Modal.scss";

interface ModalProps {
  closeModal?: () => void;
  width?: string;
}

const Modal: FC<ModalProps> = (props) => {
  useEffect(() => {
    toggleModalOpenClass(true);
  }, []);

  const onClose = () => {
    props.closeModal && props.closeModal();
    toggleModalOpenClass(false);
  };

  return (
    <div className="modal" onMouseDown={onClose}>
      <div
        className="modal__content"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        style={{ width: `${props.width}` }}
      >
        <div className="modal__container">
          {props.closeModal && (
            <img
              className="modal__close-icon"
              src={close}
              alt="close_icon"
              onClick={onClose}
            />
          )}
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
